  function createInsEl(zoneId) {

    const ins = document.createElement('ins');
    ins.dataset.reviveZoneid = zoneId;
    ins.dataset.reviveId = '57eda63bfa524a30a7b99d0abac33206';

    return ins
  }

  function setAdBannersforMobOrDesk() {

    const adBoxes = document.querySelectorAll('[data-content-ad]');

    adBoxes.forEach(bnrBox => {

      if (innerWidth <= 768 && bnrBox.dataset.contentAd === 'mob') {

        bnrBox.appendChild(createInsEl(bnrBox.dataset.contentZone));

      } else if (innerWidth > 768 && bnrBox.dataset.contentAd === 'desk') {

        bnrBox.appendChild(createInsEl(bnrBox.dataset.contentZone));

      }

    })
    //for temporary disabling all ads on site comment the following 4 lines of code
    //hidden class does not prevent banner system from serving ads
    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.src = '//ad.adventgroup.net/delivery/asyncjs.php';
    document.body.appendChild(script);
  }

  export {
    setAdBannersforMobOrDesk
  }